import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { ValueSign } from '@core/reports-types';

@Component({
  selector: 'reports-tooltip-footer',
  styleUrls: ['./report-tooltip-footer.component.less'],
  imports: [],
  template: `
    <div class="primary">{{ primarySlotText() }}</div>
    <div
      class="secondary"
      [class.sign-positive]="sign() === 'positive'"
      [class.sign-negative]="sign() === 'negative'"
    >
      {{ secondarySlotText() }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTooltipFooterComponent {
  public readonly primarySlotText = input<string>();
  public readonly secondarySlotText = input<string>();
  public readonly sign = input<ValueSign>();
}
